class CartDrawer extends HTMLElement {


  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.updateFreeShippingProgress();
    this.loadRelatedProducts();

    document.addEventListener('cart-updated', () => {
      this.updateFreeShippingProgress();
      this.loadRelatedProducts();
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });

      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });

    this.updateFreeShippingProgress();
    this.loadRelatedProducts();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  extractPrice(priceString) {
    if (!priceString) return 0;
    return parseFloat(priceString.replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
  }

  formatPrice(price) {
    return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  updateFreeShippingProgress() {
    const progressBar = this.querySelector('.progress');
    const progressSpan = this.querySelector('.progress_span');
    const progressContainer = this.querySelector('.progress_bar__container')
    const freeShippingPrice = Number(progressContainer.getAttribute('data-free-shipping-price'));

    const subtotal = this.extractPrice(this.querySelector('.totals__total-value').textContent); 
    const progress = Math.min((subtotal / freeShippingPrice) * 100, 100);

    progressBar.style.width = `${progress}%`;

    if (subtotal >= freeShippingPrice) {
        progressSpan.textContent = 'Você ganhou frete grátis!';
    } else {
        const remaining = freeShippingPrice - subtotal;
        progressSpan.textContent = `Faltam só R$ ${remaining.toFixed(2)} para o frete grátis`;
    }
  }

  async loadRelatedProducts() {
    this.firstProduct = this.querySelector('[data-related-id]');
    const productId = this.firstProduct?.dataset.relatedId
    fetch(window.location.origin + `/recommendations/products?product_id=${productId}&limit=1&section_id=cart-related-products&intent=related`)
        .then(response => response.text())
        .then(async (text) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const recommendations = doc.querySelector('#cart-related-products');
            const cartRelated = document.querySelector('.related_product__container_cart');

            cartRelated.innerHTML = recommendations.innerHTML

            const btnSubmit = document.querySelector('.add_to_cart_related');

            btnSubmit.addEventListener('click', async () => {
              const id = btnSubmit.dataset.productId;
              const quantity = document.querySelector('.quantity_related_product').value;

              const data = {
                  items: [
                      {
                          id: id,
                          quantity: quantity
                      }
                  ]
              }

              const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(data)
              });

              window.location.reload();
          });
        })
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);